import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

export interface AdminUser {
  id: number
  username: string
  role: 'operator' | 'finance' | 'super_admin'
}

interface AuthState {
  token: string | null
  admin: AdminUser | null
  login: (token: string, admin: AdminUser) => void
  logout: () => void
  isAuthenticated: () => boolean
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      token: null,
      admin: null,
      login: (token, admin) => set({ token, admin }),
      logout: () => set({ token: null, admin: null }),
      isAuthenticated: () => !!get().token,
    }),
    {
      name: 'ppnew-admin-auth',
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
)
